// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".diaBtns[data-v-03d27a00]{width:80px;padding:10px}.glo_bgcMainColor[data-v-03d27a00]{background-color:#ef7c0a!important;color:#fff!important;border:none!important}", ""]);
// Exports
module.exports = exports;
